import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityType } from 'api'
import { ReferenceRateHelper } from 'model'
import { MultiCombobox } from 'view/components/options'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { Field } from 'view/components/inputs'
import { validReferenceRateSelector } from '../../../selectors/referenceRateSelectors'

const referenceRateMapStateToProps = createStructuredSelector({
  optionKeys: validReferenceRateSelector,
  getOption: createEntityGetterSelector(EntityType.REFERENCE_RATE)
})

export const ReferenceRateMultiCombobox = connect(referenceRateMapStateToProps, null, null, { forwardRef: true })(MultiCombobox)

ReferenceRateMultiCombobox.defaultProps = {
  getOptionText: ReferenceRateHelper.getName
}

export const ReferenceRateMultiComboboxField = Field(ReferenceRateMultiCombobox)
